import { render, staticRenderFns } from "./SimplePayPaymentResult.vue?vue&type=template&id=5ffe1587&"
import script from "./SimplePayPaymentResult.vue?vue&type=script&lang=js&"
export * from "./SimplePayPaymentResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports